import ResourcesContainer from './ResourcesContainer';

export {
    ResourcesContainer
};

export default ResourcesContainer;